export default "__VITE_ASSET__BSxWIHmF__"